// Texte der Berichte (Agent 7A). Deutsche Begriffe wie im restlichen CRM.
import type { BerichtArt } from "../api/berichte";

export const BT = {
  titel: "Berichte",
  reiter: {
    uebersicht: "Aktivitätsübersicht",
    vergleich: "Aktivitätsvergleich",
    trichter: "Opportunity-Trichter",
    anrufe: "Anrufe",
    statuswechsel: "Statuswechsel",
    gesendet: "Gesendete E-Mails",
  } satisfies Record<BerichtArt, string>,
  neuerBericht: "Neuer Bericht",
  speichern: "Speichern",
  speichernUnter: "Speichern unter …",
  geaendert: "Geändert",
  alleLeads: "Alle Leads",
  alleNutzer: "Alle Nutzer",
  nurEigene: "Nur deine Zahlen",
  nurEigeneHinweis: "Du siehst nur deine eigenen Zahlen. Die Zahlen aller Nutzer sehen Admins und Super User.",
  keinVergleich: "Kein Vergleich",
  vorperiode: "Vorperiode",
  vorjahr: "Vorjahr",
  vergleichen: "Vergleichen mit",
  kachelHinzu: "Kachel hinzufügen",
  keineDaten: "Keine Daten im Zeitraum.",
  laedt: "Zahlen werden gerechnet …",
  csv: "Als CSV laden",
  linkKopieren: "Link kopieren",
} as const;

export const PFADE: Record<BerichtArt, string> = {
  uebersicht: "/reports",
  vergleich: "/reports/vergleich",
  trichter: "/reports/trichter",
  anrufe: "/reports/anrufe",
  statuswechsel: "/reports/statuswechsel",
  gesendet: "/reports/gesendet",
};
